export default __webpack_public_path__ + "locales/pl/Translations.json?hash=a8a27ba4645f328fd78c85d935e31ec6";